module.exports = __webpack_public_path__ + "img/initials.6a1d881d.svg";